import React, { useEffect } from 'react'
import styles from './TypeSection.module.scss'
import { LabeledDropdown } from 'components/common'
import { observer } from 'mobx-react-lite'
import { inject } from 'mobx-react'
import { PROJECT_STORE } from 'store'
import { Props } from './types'
import { ApiVovSubtypes, ProjectTypes, ApiProjectTypes } from 'models'

const TypeSection = (props: Props) => {
  const {
    type,
    subtype,
    setTypeAndSubtype,
    editProject,
    [PROJECT_STORE]: {
      projectTypeOptions
    }
  } = props

  useEffect(() => {
    if (!editProject && projectTypeOptions && projectTypeOptions.length === 1) {
      const onlyOption = projectTypeOptions[0]
      if (type === onlyOption) return
      setTypeAndSubtype(onlyOption, '' as ApiVovSubtypes)
    }

    if (type && !projectTypeOptions.includes(type)) {
      setTypeAndSubtype('' as ProjectTypes, '' as ApiVovSubtypes)
    }
  }, [projectTypeOptions, setTypeAndSubtype, type, editProject])

  const onTypeSelect = ([value]) => {
    setTypeAndSubtype(value, '' as ApiVovSubtypes)
  }

  const onSubtypeSelect = ([value]) => {
    setTypeAndSubtype(type, value)
  }

  const isTypeVov = type === ApiProjectTypes.VOV

  const subtypeStyles = [styles.dropdown, styles.subtypeDropdown]

  return (
    <div className={styles.container}>
      <LabeledDropdown
        options={editProject ? [type] : projectTypeOptions}
        label='Type'
        onSelect={onTypeSelect}
        selectedOptions={[type]}
        className={styles.dropdown}
      />
      {isTypeVov &&
        <LabeledDropdown
          options={Object.values(ApiVovSubtypes)}
          label='Subtype'
          onSelect={onSubtypeSelect}
          selectedOptions={[subtype]}
          className={subtypeStyles.join(' ')}
        />}
    </div>
  )
}

export default inject(PROJECT_STORE)(observer(TypeSection))
